import { ActivateBillingDialog } from '@api/services/Dialog/ActivateBillingDialog';
import { BillingPaths } from '@api/services/dictionaries/paths';
import { usePlanListUrl } from '@api/services/hooks/usePlanListUrl';
import { ShowDialog } from '@api/store/dialog/actions';
import { getProviders, LoadPaymentProviders } from '@api/store/payments/actions';
import { getProductStore } from '@api/store/products/actions';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentPlanStatus } from './useCurrentPlanStatus';

export const useActivateBillingDialog = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { dashboards } = useSelector(getProductStore);
    const providers = useSelector(getProviders);
    const planListUrl = usePlanListUrl();
    const { isTrialOrFree } = useCurrentPlanStatus();

    useEffect(() => {
        if (!providers) dispatch(LoadPaymentProviders());
    }, []);

    const showActivateBilling = useCallback(() => {
        const pathToReturn = !isTrialOrFree && !providers?.length ? BillingPaths.AddPaymentMethod : planListUrl;

        dispatch(
            ShowDialog({
                body: <ActivateBillingDialog />,
                title: t('activatebillingplan'),
                confirmLabel: t('activate'),
                cancelLabel: t('cancel'),
                fullScreen: false,
                onClickConfirm: (): void => {
                    window.location.assign(`${location.origin}${pathToReturn}`);
                },
            })
        );
    }, [dashboards, providers]);

    const isBillingActive = !isTrialOrFree && providers?.length;

    return {
        showActivateBilling,
        isBillingActive,
    };
};
